import api from './axios';

export const listar       = ()               => api.get('/modelos-uniforme/');
export const buscarId     = (id)             => api.get(`/modelos-uniforme/${id}`);
export const criar        = (data)           => api.post('/modelos-uniforme/', data);
export const atualizar    = (id, data)       => api.patch(`/modelos-uniforme/${id}`, data);
export const uploadFoto   = (id, formData)   => api.post(`/modelos-uniforme/${id}/fotos`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const deletarFoto  = (idModelo, idFoto) => api.delete(`/modelos-uniforme/${idModelo}/fotos/${idFoto}`);
